import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight, X } from 'lucide-react';

const SEEN_KEY = 'mibeko_cat_intros_seen';

export const getSeenIntros = () => {
  try {
    return JSON.parse(localStorage.getItem(SEEN_KEY)) || {};
  } catch {
    return {};
  }
};

export const markIntroSeen = (catId) => {
  try {
    const seen = getSeenIntros();
    seen[catId] = true;
    localStorage.setItem(SEEN_KEY, JSON.stringify(seen));
  } catch {}
};

const CategoryIntroModal = ({ category, onClose }) => {
  const navigate = useNavigate();
  if (!category || !category.intro) return null;
  const catId = category.id;

  const goTo = () => {
    markIntroSeen(catId);
    onClose();
    navigate(`/categorie/${catId}`);
  };

  const dismiss = () => {
    markIntroSeen(catId);
    onClose();
  };

  return (
    <div
      data-testid="category-intro-overlay"
      onClick={dismiss}
      style={{
        position: 'fixed', inset: 0, zIndex: 10000,
        background: 'rgba(11, 18, 32, 0.65)',
        backdropFilter: 'blur(4px)', WebkitBackdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
      }}
    >
      <div
        data-testid="category-intro-modal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        style={{
          background: 'var(--bg-white)', borderRadius: '16px',
          padding: '26px 22px 22px', maxWidth: '420px', width: '100%',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)', position: 'relative',
        }}
      >
        <button
          onClick={dismiss}
          data-testid="category-intro-close-btn"
          aria-label="Fermer"
          style={{
            position: 'absolute', top: '12px', right: '12px',
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'var(--text-gray)', padding: '4px', display: 'flex',
          }}
        >
          <X style={{ width: 18, height: 18 }} />
        </button>
        <h2
          data-testid="category-intro-title"
          style={{ fontSize: '18px', fontWeight: 700, color: 'var(--text-dark)', marginBottom: '10px' }}
        >
          {category.name}, c&apos;est quoi ?
        </h2>
        <p
          data-testid="category-intro-text"
          style={{ fontSize: '14px', lineHeight: 1.65, color: 'var(--text-gray)', marginBottom: '20px' }}
        >
          {category.intro}
        </p>
        <button
          onClick={goTo}
          data-testid="category-intro-access-btn"
          style={{
            width: '100%', padding: '13px',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
            background: 'var(--primary)', color: '#fff',
            border: 'none', borderRadius: '10px',
            fontSize: '14px', fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
          }}
        >
          Accéder <ArrowRight style={{ width: 16, height: 16 }} />
        </button>
      </div>
    </div>
  );
};

export default CategoryIntroModal;
